import { render, staticRenderFns } from "./hander.vue?vue&type=template&id=125935b2&scoped=true"
import script from "./hander.vue?vue&type=script&lang=js"
export * from "./hander.vue?vue&type=script&lang=js"
import style0 from "./hander.vue?vue&type=style&index=0&id=125935b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125935b2",
  null
  
)

export default component.exports